import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../../utils";
/**
 * Display field for read-only content. See `variant` for the two supported
 * visual treatments.
 */ export const ReadOnlyField = /*#__PURE__*/ React.forwardRef(function ReadOnlyField({ variant = "pill", label, icon, mono, value, className, children, ...props }, ref) {
    const display = value ?? children;
    if (variant === "stacked") {
        return /*#__PURE__*/ _jsxs("div", {
            ref: ref,
            className: cn("flex flex-col gap-1", className),
            ...props,
            children: [
                label && /*#__PURE__*/ _jsx("span", {
                    className: "text-sm font-medium text-muted-foreground",
                    children: label
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: cn("text-sm", mono && "font-mono"),
                    children: display ?? "—"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        ref: ref,
        className: cn("flex items-center gap-2 rounded-[10px] border border-dashed border-line bg-surface-subtle px-3 py-2.5 text-[13.5px] text-fg-secondary", mono && "font-mono", className),
        ...props,
        children: [
            icon && /*#__PURE__*/ _jsx("span", {
                className: "text-fg-subtle",
                children: icon
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "min-w-0 flex-1 truncate",
                children: display
            })
        ]
    });
});

//# sourceMappingURL=ReadOnlyField.js.map